<template>
    <aside>
<div class="pattern">

</div>
</aside>
</template>

<style scoped lang="scss">
aside {
  grid-area:aside;
 margin:0;
 display:flex;
 justify-content:flex-end;
}
.pattern {
  width:100%;
  height:100%;
  background: url("/images/o2o-side-pattern.png") top right repeat-y;
  background-size:contain;
  max-width:200px;

  @media (min-width:1440px) {
    background: url("/images/o2o-side-pattern.png") top right repeat-y;
    background-size:contain;
    max-width: 300px;
  }
 
}
</style>

<script>
export default {
  name: "Aside",
  methods: {
      goToChat() {
        this.$router.push('/chat/situation/new/');
        this.changeMode("chat");
      }
      }
  
};
</script>
